import { refreshToken as refreshTokenFromApi, login, forgotPassword, resetPassword } from '../api'
import { saveToken, signOut, getToken } from '../../services/authService'
import Vue from 'vue'

export const doLogin = async ({ commit, dispatch, getters }, data) => {
  await signOut()
  try {
    const res = await login(data)
    if (res && res instanceof Error) throw res
    if (res.hasOwnProperty('access_token') === true) {
      await saveToken('token', res)
      commit('LOGIN', res)
      commit('TOAST_LOGIN', data.username)
      return res
    }
    commit('LOGOUT', res)
  } catch (err) {
    if (err.toast) commit('TOAST_ERROR', 'Invalid credentials!')
    return false
  }
}

export const doLogout = async ({ commit, dispatch, getters }, data) => {
  commit('TOAST_LOGOUT', getters.getMyInfo.email)
  await signOut()
  Vue.$socketApi.disconnect()
  commit('RESETSTATE', null)
  commit('LOGOUT', null)
}

export const loadToken = async ({ commit }, data) => {
  try {
    const token = await getToken('token')
    if (token && token.access_token) {
      commit('LOGIN', token)
      return true
    } else {
      commit('LOGOUT', null)
      return false
    }
  } catch (err) {
    throw err
  }
}

export const refreshToken = async ({ commit }, data) => {
  const token = await getToken('token')
  if (token && token.refresh_token) {
    const newToken = await refreshTokenFromApi(token)
    await saveToken('token', newToken)
    commit('REFRESH', newToken)
    return newToken
  }
}

export const doForgotPassword = async ({ commit }, data) => {
  let res
  try {
    res = await forgotPassword(data)
    commit('LOGOUT', res)
    return res
  } catch (error) {
    commit('LOGOUT', res)
    return false
  }
}
export const doResetPassword = async ({ commit, dispatch }, data) => {
  try {
    const res = await resetPassword(data)
    if (res.hasOwnProperty('access_token') === true) {
      await saveToken('token', res)
      commit('LOGIN', res)
      commit('PASSWORD_RESET', true)
      commit('TOAST_PASSWORD', 'Password successfuly reset!')
      return res
    }
  } catch (err) {
    dispatch('checkNested', {obj: err, props: ['response', 'data']}).then((res) => {
      commit('RESETPASSWORDERROR', res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/store/login/actions.js